// extracted by mini-css-extract-plugin
export var breadcrumb = "_7-2";
export var breadcrumbArrow = "_7-3";
export var breadcrumbs = "_7-0";
export var link = "_7-4";
export var small = "_7-1";